import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OrderBuyNowQuery, OrderByNow } from './type';

/**
 * 直接购买下单
  POST /api/order/buyer/buy/now
  接口ID：236224011
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-236224011
 */
export const postBuyNow = (data: OrderBuyNowQuery): AxiosPromise<OrderByNow> => {
  return request({
    url: '/api/order/buyer/buy/now',
    method: 'post',
    data
  });
};
